var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8963 4.75915L13.4295 3.94908C13.0346 3.26364 12.1594 3.02718 11.473 3.42048V3.42048C11.1462 3.61295 10.7564 3.66756 10.3894 3.57226C10.0223 3.47696 9.70827 3.23958 9.51645 2.91247C9.39305 2.70455 9.32674 2.46774 9.32423 2.22597V2.22597C9.33536 1.83836 9.18913 1.46274 8.91884 1.18469C8.64855 0.906645 8.27722 0.74984 7.88945 0.75H6.94895C6.56905 0.749996 6.20481 0.901379 5.93682 1.17065C5.66884 1.43992 5.5192 1.80489 5.52103 2.18478V2.18478C5.50977 2.96914 4.87068 3.59905 4.08625 3.59897C3.84448 3.59646 3.60766 3.53015 3.39975 3.40675V3.40675C2.71337 3.01345 1.83816 3.24991 1.44322 3.93535L0.942081 4.75915C0.547628 5.44374 0.780871 6.3184 1.46382 6.71568V6.71568C1.90775 6.97197 2.18122 7.44564 2.18122 7.95824C2.18122 8.47084 1.90775 8.9445 1.46382 9.2008V9.2008C0.781738 9.5954 0.548241 10.4679 0.942081 11.1505V11.1505L1.41576 11.9674C1.60081 12.3013 1.91127 12.5477 2.27847 12.652C2.64566 12.7564 3.0393 12.7101 3.37229 12.5235V12.5235C3.69963 12.3324 4.08971 12.2801 4.45583 12.3781C4.82194 12.4761 5.13375 12.7162 5.32194 13.0452C5.44534 13.2531 5.51165 13.4899 5.51416 13.7317V13.7317C5.51416 14.5241 6.15654 15.1665 6.94895 15.1665H7.88945C8.67918 15.1665 9.32045 14.5283 9.32423 13.7386V13.7386C9.32239 13.3575 9.47297 12.9915 9.74244 12.722C10.0119 12.4525 10.3779 12.3019 10.759 12.3038C11.0002 12.3102 11.236 12.3763 11.4455 12.496V12.496C12.1301 12.8904 13.0048 12.6572 13.402 11.9743V11.9743L13.8963 11.1505C14.0876 10.8221 14.1401 10.431 14.0422 10.0637C13.9443 9.6965 13.704 9.38346 13.3746 9.19394V9.19394C13.0451 9.00441 12.8049 8.69138 12.7069 8.32415C12.609 7.95692 12.6615 7.56581 12.8528 7.23741C12.9773 7.02019 13.1574 6.84009 13.3746 6.71568V6.71568C14.0534 6.31861 14.2861 5.44906 13.8963 4.76602V4.76602V4.75915Z",
    stroke: "#383F43",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.42267,
    cy: 7.95824,
    r: 1.97712,
    stroke: "#383F43",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/Setting.c6e1c59de789f92a68562d2a1b87ea0a.svg";
export { ForwardRef as ReactComponent };